const highlightText = (textSnippet, searchTerm) => {
    const characterIndex = textSnippet.toLowerCase().indexOf(searchTerm.toLowerCase());
    const actualTermCaseSensitive = textSnippet.slice(characterIndex, characterIndex + searchTerm.length);
    const highlightedSnippet = textSnippet.replace(actualTermCaseSensitive, `<mark >${actualTermCaseSensitive}</mark>`)
    return highlightedSnippet;
}

export default highlightText;